import React from "react";
import { Formik } from "formik";
import useCurrentUser from "hooks/useCurrentUser";
import { useBulkImportFromRepo, useBulkUploadEventDefs } from "security-app/hooks/useSigmaAPI";
import { SelectedRowsProvider } from "common/contexts";
import {
  PATH_ACTIONS,
  INITIAL_SIGMA_EVENT_DEFINITION,
  INITIAL_FILE_UPLOAD_EVENT_DEFINITION,
  overridesMapToPayload,
  fileOverridesToPayload,
  useValidations
} from "./utils";
import Form from "./Form";
function FormContainer({ pathAction }) {
  const currentUser = useCurrentUser();
  const { bulkImportFromRepo } = useBulkImportFromRepo();
  const { bulkUploadEventDefs } = useBulkUploadEventDefs();
  const initialValues = pathAction === PATH_ACTIONS.gitImport ? INITIAL_SIGMA_EVENT_DEFINITION : INITIAL_FILE_UPLOAD_EVENT_DEFINITION;
  const validate = useValidations(pathAction);
  const onSubmit = async (values) => {
    if (pathAction === PATH_ACTIONS.gitImport) {
      const { rule_overrides, share_request } = values;
      await bulkImportFromRepo({
        entity: { rule_overrides: overridesMapToPayload(rule_overrides != null ? rule_overrides : {}) },
        share_request
      });
    } else {
      const { files, file_overrides, share_request } = values;
      await bulkUploadEventDefs({
        files,
        file_overrides: fileOverridesToPayload(file_overrides != null ? file_overrides : {}, files != null ? files : []),
        share_request
      });
    }
  };
  return /* @__PURE__ */ React.createElement(SelectedRowsProvider, null, /* @__PURE__ */ React.createElement(Formik, { initialValues, onSubmit, validate }, /* @__PURE__ */ React.createElement(Form, { pathAction, currentUser })));
}
export default FormContainer;
